import React, { useEffect, useState } from 'react';
import { FiCheckCircle, FiFileText, FiLink, FiShield, FiClock, FiX } from 'react-icons/fi';
import api from '../utils/api';

function formatearFecha(fecha) {
  if (!fecha) return '—';
  const d = new Date(fecha);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('es-ES');
}

export default function DocumentosFirma() {
  const [documentos, setDocumentos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [detalle, setDetalle] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      setCargando(true);
      setError('');
      try {
        const { data } = await api.get('/firma/documentos');
        setDocumentos(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('ERROR cargar documentos de firma ->', err);
        setError(err.response?.data?.error || 'No se pudieron cargar los documentos de firma.');
      } finally {
        setCargando(false);
      }
    };

    cargar();
  }, []);

  const abrirDetalle = async (id) => {
    if (!id) return;
    setCargandoDetalle(true);
    try {
      const { data } = await api.get(`/firma/documentos/${id}`);
      setDetalle(data);
    } catch (err) {
      console.error('ERROR cargar detalle de documento firma ->', err);
      setError(err.response?.data?.error || 'No se pudo cargar el detalle del documento.');
    } finally {
      setCargandoDetalle(false);
    }
  };

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1 className="page-title">Documentos de firma</h1>
          <p className="page-subtitle">Historial de presupuestos y facturas enviados para firma digital.</p>
        </div>
      </div>

      {cargando ? (
        <div className="empty">Cargando documentos de firma…</div>
      ) : error ? (
        <div className="alert-error">{error}</div>
      ) : documentos.length === 0 ? (
        <div className="empty">Todavía no se ha enviado ningún documento para firma digital.</div>
      ) : (
        <div className="card" style={{ overflow: 'hidden' }}>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Número</th>
                  <th>Cliente</th>
                  <th>Estado</th>
                  <th>Enviado</th>
                  <th>Firmado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {documentos.map((doc) => {
                  const tipo = doc.tipoDocumento === 'factura' ? 'Factura' : 'Presupuesto';
                  const cliente = doc.cliente?.nombre || 'Cliente';
                  const estado = doc.estado === 'firmada' ? 'Firmado' : doc.estado === 'pendiente' ? 'Pendiente' : doc.estado || '—';

                  return (
                    <tr key={doc._id} onDoubleClick={() => abrirDetalle(doc._id)} style={{ cursor: 'pointer' }} title="Doble clic para abrir el detalle del documento">
                      <td data-label="Tipo"><span className="badge badge-info">{tipo}</span></td>
                      <td data-label="Número"><strong>{doc.numero || doc.documento?.numero || '—'}</strong></td>
                      <td data-label="Cliente">{cliente}</td>
                      <td data-label="Estado">
                        {doc.estado === 'firmada' ? (
                          <span className="badge badge-ok"><FiCheckCircle /> Firmado</span>
                        ) : doc.estado === 'pendiente' ? (
                          <span className="badge badge-warning"><FiClock /> Pendiente</span>
                        ) : (
                          <span className="badge badge-info"><FiShield /> {estado}</span>
                        )}
                      </td>
                      <td data-label="Enviado">{formatearFecha(doc.createdAt)}</td>
                      <td data-label="Firmado">{formatearFecha(doc.firmadoAt)}</td>
                      <td data-label="Acciones">
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                          <a href={doc.publicUrl} target="_blank" rel="noreferrer" className="btn btn-sm">
                            <FiLink /> Ver enlace
                          </a>
                          {doc.pdfFirmadoDisponible && (
                            <a href={doc.pdfFirmadoUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-primary">
                              <FiFileText /> PDF firmado
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {detalle && (
        <div className="modal-overlay" onClick={() => setDetalle(null)}>
          <div className="modal" style={{ maxWidth: 1200 }} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
            <div className="modal-header">
              <h3>{detalle.tipoDocumento === 'factura' ? 'Factura' : 'Presupuesto'} · {detalle.numero || detalle.documento?.numero || 'Documento'}</h3>
              <button className="modal-close" onClick={() => setDetalle(null)} aria-label="Cerrar"><FiX /></button>
            </div>
            <div className="modal-body">
              {cargandoDetalle ? (
                <div className="empty">Cargando detalle del documento…</div>
              ) : (
                <>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginBottom: 16 }}>
                    <div className="card" style={{ padding: 12 }}><strong>Cliente:</strong><br />{detalle.cliente?.nombre || '—'}</div>
                    <div className="card" style={{ padding: 12 }}><strong>NIF:</strong><br />{detalle.cliente?.nif || '—'}</div>
                    <div className="card" style={{ padding: 12 }}><strong>Estado:</strong><br />{detalle.estado || '—'}</div>
                    <div className="card" style={{ padding: 12 }}><strong>Firmado por:</strong><br />{detalle.firmadoPorNombre || '—'}</div>
                    <div className="card" style={{ padding: 12 }}><strong>NIF firmante:</strong><br />{detalle.firmadoPorNif || '—'}</div>
                    <div className="card" style={{ padding: 12 }}><strong>Fecha firma:</strong><br />{formatearFecha(detalle.firmadoAt)}</div>
                    <div className="card" style={{ padding: 12 }}><strong>IP:</strong><br />{detalle.ip || '—'}</div>
                    <div className="card" style={{ padding: 12 }}><strong>Hash:</strong><br />{detalle.hashDocumento || '—'}</div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                    <div style={{ border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
                      <div style={{ padding: '10px 12px', background: '#f8fafc', borderBottom: '1px solid var(--border)', fontWeight: 700 }}>Documento enviado a firmar</div>
                      <iframe src={detalle.pdfUrl || detalle.publicUrl || '#'} title="Documento enviado" style={{ width: '100%', minHeight: 620, border: 'none', background: '#fff' }} />
                    </div>

                    <div style={{ border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
                      <div style={{ padding: '10px 12px', background: '#f8fafc', borderBottom: '1px solid var(--border)', fontWeight: 700 }}>Documento firmado con la firma superpuesta</div>
                      {detalle.pdfFirmadoDisponible && detalle.pdfFirmadoUrl ? (
                        <iframe src={detalle.pdfFirmadoUrl} title="Documento firmado" style={{ width: '100%', minHeight: 620, border: 'none', background: '#fff' }} />
                      ) : (
                        <div className="empty">No hay PDF firmado disponible.</div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
